<ng-container>
  <div class="ppl-container-body">
    <div class="ppl-container-head">
      <div class="details-header">
        <ppl-button label="Back" icon="fa fa-chevron-left" [customClass]="'ghost-button'" iconPosition="left"
          (click)="goBack()">
        </ppl-button>
        <h1 class="page-title-accessibility">{{ pageTitle }}</h1>
      </div>
    </div>
    <div class="ppl-container">
      <div class="ppl-content-container">
        <div class="table-style">
          @if (programName && jsonListPageName) {
          <ppl-list-table #MassBatchResult [pageConfig]="programName" [loadPage]="lazyLoad"
            [sharedDataKey]="sharedDataKey" [jsonList]="jsonListPageName" [tableWidth]="'100%'" [tableScrollable]="true"
            tableScrollHeight="flex" [dataLoader]="massAdjustmentsDataLoader" [recordsPerPage]="20"
            [enablePageActions]="!isReadOnly" (actionInvoked)="onListAction($event)">
          </ppl-list-table>

          }

        </div>
      </div>
    </div>
  </div>
</ng-container>
<ppl-popup-dialog [(isVisible)]="showDialog" title="Exclude Bulk Adjustments Results" [showClose]="true" [showButtons]="true"
  [showOkButton]="false" [hideSaveButton]="!comments || comments.trim().length === 0" size="medium" position="center"
  (confirm)="onConfirm()">
  <div>
    <p class="dialog-intro">
      Are you sure you want to Exclude Selected Adjustment Results?
    </p>
    <strong>Selected records: {{ selectedRows?.length }}</strong>
    <div class="comment-section">
      <label [attr.for]="'ExcludeComments'">
        <strong>Comments<span style="color: red;"> *</span></strong>
      </label>
      <textarea [id]="'ExcludeComments'" [(ngModel)]="comments" [placeholder]="'Please provide reason'" rows="4"
        style="width: 100%; margin-top: 8px; padding: 8px; border: 1px solid #d9d9d9; border-radius: 4px;">
          </textarea>
    </div>
  </div>
</ppl-popup-dialog>